'use client';

// Keep the historical marketplace destination while sharing the consumer stream
// with agora.red. Automatic cookie scope preserves the session across subdomains.
const GOOGLE_DESTINATIONS = ['G-BR7KM2J62S', 'G-KMWPWJ0FVS'];
const configured = new Set();

function ensureGoogleEventQueue() {
  if (typeof window === 'undefined') return null;

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
  }

  for (const id of GOOGLE_DESTINATIONS) {
    if (!configured.has(id)) {
      configured.add(id);
      window.gtag('config', id, { cookie_domain: 'auto' });
    }
  }
  return window.gtag;
}

export function trackGoogleEvent(eventName, parameters = {}) {
  const gtag = ensureGoogleEventQueue();
  if (gtag) gtag('event', eventName, parameters);
}

export { ensureGoogleEventQueue };
